// extracted by mini-css-extract-plugin
export default {"hideTooltip":"m--z","fadeIn":"n--z","delay":"o--z","recommendedSizeTooltip":"p--z"};